import React, { ReactNode, createContext, useContext, useMemo } from "react";

import { CIFARelationRaw } from "@/domain/CIFARelation";
import { useAdminAPI } from "../hooks";

const ctx = createContext<{
  ciFARelations: CIFARelationRaw[] | null;
  runReloadCIFARelations: () => Promise<void>;
  isLoadedCIFARelations: boolean;
}>({
  ciFARelations: null,
  runReloadCIFARelations: async () => {
    // nop
  },
  isLoadedCIFARelations: false,
});

export const AdminCIFARelationsProvider: React.FC<{
  children: ReactNode;
}> = ({ children }) => {
  const {
    state: ciFARelations,
    runReloadState: runReloadCIFARelations,
    isLoadedState: isLoadedCIFARelations,
  } = useAdminAPI<CIFARelationRaw[]>("ciFARelations");

  const ctxValue = useMemo(
    () => ({
      ciFARelations,
      runReloadCIFARelations,
      isLoadedCIFARelations,
    }),
    [ciFARelations, runReloadCIFARelations, isLoadedCIFARelations]
  );

  return <ctx.Provider value={ctxValue}>{children}</ctx.Provider>;
};

export const useAdminCIFARelations = () => {
  return useContext(ctx);
};
